export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";